const errorHandlerFactory = message => (error) => {
    let detailedMessage = 'An unknown error has occured.';
    let showError = true;
    if (error.response) {
        const { status } = error.response;
        if (status === 400) {
            detailedMessage = 'The request is invalid.';
        } else if (status === 401) {
            detailedMessage = 'You must be authenticated to use this service.';
        } else if (status === 403) {
            showError = false;
        } else if (status === 404) {
            detailedMessage = 'The service you requested could not be found.';
        } else if (status < 500) {
            detailedMessage = 'There is an unknown error in the request.';
        } else if (status >= 500) {
            detailedMessage = 'There was a server error when attempting to process the request.';
        }
    } else if (error.request) {
        detailedMessage = 'The request was sent but no response was received.';
    } else {
        detailedMessage = 'An error has prevented the request from being sent.';
    }
    if (showError){
        throw new Error(`${message}\n\n${detailedMessage}`);
    }    
};

export default errorHandlerFactory;
